module.exports = __webpack_public_path__ + "static/media/logo.bcc287ea.svg";